import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RContextHelperClass;
function RContextHelper() {
  if (RContextHelperClass === VOID) {
    class $ {
      constructor() {
        this.ub3_1 = HashMap().n8();
      }
    }
    initMetadataForClass($, 'RContextHelper');
    RContextHelperClass = $;
  }
  return RContextHelperClass;
}
//region block: exports
export {
  RContextHelper as RContextHelperenwj28riclsp,
};
//endregion

//# sourceMappingURL=RContext.mjs.map
